import type { BoardTask } from './api'

export const BOARD_PRIORITY_TONE: Record<BoardTask['priority'], string> = {
  low: 'bg-muted text-muted-foreground',
  normal: 'bg-info/10 text-info',
  high: 'bg-warning/12 text-warning',
  urgent: 'bg-destructive/10 text-destructive',
}

export function isBoardTaskOverdue(task: BoardTask, done: boolean) {
  return !done && !!task.dueAt && new Date(task.dueAt).getTime() < Date.now()
}

/** Kolon adı → kod (küçük harf, rakam, _). Kod görevlerde saklanır; ad sonradan değiştirilebilir. */
export function columnKeyOf(name: string, taken: string[]) {
  const base =
    name
      .toLocaleLowerCase('tr')
      .replace(/[ıİ]/g, 'i')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ş/g, 's')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^[^a-z]+|_+$/g, '')
      .slice(0, 36) || 'kolon'
  let key = base.length < 2 ? `${base}_k` : base
  for (let i = 2; taken.includes(key); i++) key = `${base}_${i}`
  return key
}
